import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import ClaimsCard from './ClaimsCard';
import { GRID_CLAIMS_PER_PAGE } from './constants';

export default function GridView({ claims, page, isLoading, cardClickHandler }) {
  const claimsPerPage = GRID_CLAIMS_PER_PAGE;

  return (
    <Grid container spacing={3}>
      {claims
        .slice(
          (page - 1) * claimsPerPage,
          (page - 1) * claimsPerPage + claimsPerPage
        )
        .map(claim => (
          <Grid item key={claim.key} md={4} sm={6} xs={12}>
            <ClaimsCard claim={claim} isLoading={isLoading} cardClickHandler={cardClickHandler} />
          </Grid>
        )
        )}
    </Grid>
  )
}

GridView.propTypes = {
  claims: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      claimStatus: PropTypes.string,
      currentDisposition: PropTypes.string,
      lastUpdateDate: PropTypes.string,
      reviewer: PropTypes.number,
      claimantName: PropTypes.string,
      claimIdentifier: PropTypes.string,
      amountRequested: PropTypes.number,
      claimType: PropTypes.string,
      coverageName: PropTypes.string,
      policyNumber: PropTypes.string,
      policyMember: PropTypes.string,
      vin: PropTypes.string
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  cardClickHandler: PropTypes.func
};
